document.addEventListener('DOMContentLoaded',()=>{
  const b=document.querySelector('[data-menu-toggle]');
  const n=document.querySelector('[data-nav]');
  if(b&&n)b.addEventListener('click',()=>n.classList.toggle('open'));
});


// K73 Base Station utilities
(() => {
  const pad = n => String(n).padStart(2,'0');
  function tick(){
    const d = new Date();
    const utc = `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
    const loc = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    document.querySelectorAll('[data-k73-utc]').forEach(e=>e.textContent=utc.slice(0,5)+' UTC');
    document.querySelectorAll('[data-k73-local]').forEach(e=>e.textContent=loc.slice(0,5)+' LOCAL');
    document.querySelectorAll('[data-k73-utc-big]').forEach(e=>e.textContent=utc);
    document.querySelectorAll('[data-k73-local-big]').forEach(e=>e.textContent=loc);
  }
  tick(); setInterval(tick,1000);

  const solarStatus = document.querySelector('[data-k73-solar-status]');
  if(solarStatus){
    fetch('https://funkr.org/api/funkwetter.json', {cache:'no-store'})
      .then(r=>{ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(d=>{
        const s=d.solar||{};
        const put=(sel,val)=>{const e=document.querySelector(sel); if(e)e.textContent=(val ?? '–');};
        put('[data-k73-sfi]',s.solarflux); put('[data-k73-k]',s.kindex); put('[data-k73-a]',s.aindex); put('[data-k73-ssn]',s.sunspots);
        solarStatus.textContent=`Geomagnetisch: ${s.geomagfield||'–'} · X-Ray: ${s.xray||'–'} · automatisch aktualisiert`;
        const bands=d.bands||{};
        document.querySelectorAll('[data-k73-bands] span').forEach(el=>{
          const key=el.textContent.toLowerCase().replace(/\s*cb/,'').trim();
          const raw=bands[key] || bands[key.replace('m','')] || '';
          const txt=typeof raw==='string'?raw:(raw.day||raw.night||raw.status||'');
          el.classList.remove('good','mid','bad');
          if(/gut|good|open|excellent/i.test(txt)) el.classList.add('good');
          else if(/mittel|fair|medium/i.test(txt)) el.classList.add('mid');
          else if(txt) el.classList.add('bad');
          if(txt) el.title=txt;
        });
      })
      .catch(()=>{solarStatus.textContent='Live-Funkwetter derzeit nicht erreichbar – Quelle über den Link öffnen.';});
  }

  function locatorToLatLon(grid){
    grid=(grid||'').trim().toUpperCase();
    if(!/^[A-R]{2}[0-9]{2}([A-X]{2})?([0-9]{2})?$/.test(grid)) throw new Error('Ungültiger Locator');
    let lon=(grid.charCodeAt(0)-65)*20-180, lat=(grid.charCodeAt(1)-65)*10-90;
    lon+=parseInt(grid[2],10)*2; lat+=parseInt(grid[3],10);
    let lonSize=2, latSize=1;
    if(grid.length>=6){lon+=(grid.charCodeAt(4)-65)*(5/60); lat+=(grid.charCodeAt(5)-65)*(2.5/60); lonSize=5/60; latSize=2.5/60;}
    if(grid.length>=8){lon+=parseInt(grid[6],10)*(0.5/60); lat+=parseInt(grid[7],10)*(0.25/60); lonSize=0.5/60; latSize=0.25/60;}
    return [lat+latSize/2,lon+lonSize/2];
  }
  function distanceKm(a,b){
    const R=6371, rad=x=>x*Math.PI/180;
    const dLat=rad(b[0]-a[0]), dLon=rad(b[1]-a[1]);
    const q=Math.sin(dLat/2)**2+Math.cos(rad(a[0]))*Math.cos(rad(b[0]))*Math.sin(dLon/2)**2;
    return 2*R*Math.asin(Math.sqrt(q));
  }
  const calc=document.querySelector('[data-loc-calc]');
  if(calc) calc.addEventListener('click',()=>{
    const out=document.querySelector('[data-loc-result]');
    try{
      const a=locatorToLatLon(document.querySelector('[data-loc-a]').value);
      const b=locatorToLatLon(document.querySelector('[data-loc-b]').value);
      out.textContent=`≈ ${distanceKm(a,b).toFixed(1)} km Luftlinie`;
    }catch(e){out.textContent='Bitte gültige Maidenhead-Locators eingeben, z.B. JN47 oder JN47AA.';}
  });

  const wb=document.querySelector('[data-k73-weather]');
  if(wb) wb.addEventListener('click',()=>{
    const out=document.querySelector('[data-k73-weather-result]');
    if(!navigator.geolocation){out.textContent='Standortfunktion wird vom Browser nicht unterstützt.';return;}
    out.textContent='Standort und Funkwetter werden geladen …';
    navigator.geolocation.getCurrentPosition(pos=>{
      const {latitude,longitude}=pos.coords;
      fetch(`https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current=temperature_2m,precipitation,wind_speed_10m,wind_gusts_10m,weather_code&wind_speed_unit=kmh`)
        .then(r=>r.json()).then(d=>{
          const c=d.current||{}, wind=Number(c.wind_speed_10m||0), gust=Number(c.wind_gusts_10m||0), rain=Number(c.precipitation||0);
          let hint='Portable-Betrieb grundsätzlich gut.';
          if(gust>=50) hint='Starke Böen: Antennenmast und Abspannung kritisch prüfen.';
          else if(wind>=30) hint='Windig: Portable-Antenne gut sichern.';
          if(rain>0) hint+=' Niederschlag: Steckverbindungen und Gerät schützen.';
          out.innerHTML=`<b>${c.temperature_2m ?? '–'} °C</b> · Wind ${wind} km/h · Böen ${gust} km/h · Niederschlag ${rain} mm<br><small>${hint}</small>`;
        }).catch(()=>out.textContent='Wetterdaten konnten nicht geladen werden.');
    },()=>out.textContent='Standortfreigabe wurde nicht erteilt.');
  });
})();

(()=>{const b=document.querySelector('[data-k73-menu-toggle]'),n=document.getElementById('k73-mobile-nav');if(!b||!n)return;b.addEventListener('click',()=>{const o=n.classList.toggle('mobile-open');b.setAttribute('aria-expanded',o?'true':'false')});n.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{n.classList.remove('mobile-open');b.setAttribute('aria-expanded','false')}));})();

// v2.12 weather code hint enhancement
document.addEventListener('k73-weather-code',e=>{const o=document.querySelector('[data-k73-weather-out]');if(o&&[95,96,99].includes(Number(e.detail)))o.textContent+=' // GEWITTERWARNUNG';});
